import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import TradesIcon from '@interxfi/design-system/icons/react/icon-trades';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { IncreaseAchConfirmSyncAllDialog } from '../../../../../../../../../../features/vendor/increase/ach/increase-ach-confirm-sync-all-dialog';
import { IncreaseAchTable } from '../../../../../../../../../../features/vendor/increase/ach/increase-ach-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorIncrease,
      label: 'ACH',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorIncrease>,
  head: () => getPageHead('Increase ACH'),
  component: IncreaseAchList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <IncreaseAchConfirmSyncAllDialog
              trigger={
                <Button affixIcon={<TradesIcon aria-hidden />} aria-label="Sync All Increase ACH Transfers" size="small">
                  Sync All
                </Button>
              }
            />
          </RequiresAccess>

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingVendorIncrease}
    />
  );
}

function IncreaseAchList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <IncreaseAchTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
